// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_1PKpc_FgNg9HW7fEsgBo5L","checked":"_3tasR1Z3fC8wW9Hf0zf4L","disabled":"u-_4kw1Gun25cxewE8fIS","selected":"s4DgzNvt2R1_VkGalbRi-","oddsButtonCustom":"_1C8U7ivyCCt44Yl9fla8IQ"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/cricket/css/oddsButtonCricket.css
// module id = 948
// module chunks = 0